<template>
  <SelectUbbi
    size="sm"
    class="form-control form-control-solid form-control-sm"
    v-bind="$attrs"
  >
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
  </SelectUbbi>
</template>

<script>
import SelectUbbi from '../../../components/SelectUbbi.vue';

export default {
  name: 'ScheduleFilterSelect',
  inheritAttrs: false,
  components: { SelectUbbi },
};
</script>
